import { useLang } from "../lib/i18n";
import { Overline } from "./ui-vision";

export const ServiceComplet = () => {
  const { t } = useLang();
  const s = t.home.service;

  return (
    <section className="py-8 md:py-12 bg-ink-2 border-y border-white/5" data-testid="service-complet">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-8 items-end mb-8 md:mb-10">
          <div className="md:col-span-7">
            <Overline className="mb-6">{s.overline}</Overline>
            <h2 className="font-display text-4xl md:text-5xl font-medium tracking-tight leading-[1.05]">
              {s.title}
            </h2>
          </div>
          <div className="md:col-span-5 md:text-right">
            <p className="text-white/55 font-light max-w-sm md:ml-auto">{s.text}</p>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-10">
          {s.steps.map((step, i) => {
            const highlight = i === s.steps.length - 1;
            return (
              <div
                key={step.n}
                data-testid={`service-step-${i}`}
                className={`border-t pt-6 ${highlight ? "border-accent-yellow/50" : "border-white/15"}`}
              >
                <span className="font-display text-sm text-accent-yellow tracking-wide">{step.n}</span>
                <h3 className="mt-3 font-display text-xl md:text-2xl font-medium tracking-tight leading-tight">
                  {step.title}
                </h3>
                <p className="mt-3 text-sm text-white/55 font-light leading-relaxed">{step.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
